import { useSelector } from "react-redux"
import { selectAnnualPremiumAmount, selectEvidenceNotes, selectIsEvidenceOfInsurability, selectIsUpdateAnnualPremium, selectNELValue, selectNMLValue } from "../../features/actuarial/annual-premium-eoi.slice"
import { selectFileDocuments, selectIsDraggingDocuments, selectIsUpdateDocuments } from "../../features/actuarial/document-slice";
import { selectActNoteForCFE, selectActNotePDF, selectIsEditingNotesForProposal, selectIsEditNotesForCFE, selectIsEditNotesForProposal, selectIsShowActNotePDF, selectNoteForProposalAct } from "../../features/actuarial/remark-slice";
import { selectActiveRateTab, selectAmountWarning, selectBulkData, selectGCLIRates6670, selectGCLIRates7175, selectGCLIRates7680, selectIsUpdateRatesState, selectRatesOf1865, selectShowRatesState } from "../../features/actuarial/rates-slice";

export const useProposalComputation = () => {

    // RATES 
    const ratesActiveTab = useSelector(selectActiveRateTab);
    const isUpdateRates = useSelector(selectIsUpdateRatesState);
    const selectShowRates = useSelector(selectShowRatesState);
    // RATES 18 to 65
    const rates1865 = useSelector(selectRatesOf1865);
    // RATES: 66 to 70
    const rates6670 = useSelector(selectGCLIRates6670);
    // RATES: 71 to 75
    const rates7175 = useSelector(selectGCLIRates7175);
    // RATES: 76 to 80
    const rates7680 = useSelector(selectGCLIRates7680);

    const { 
        bulkValue, 
        bulkWarning, 
        isBulkFillOpen, 
        selectedMonths,
        activeAgeBracket
    } = useSelector(selectBulkData);
    const amountWarning = useSelector(selectAmountWarning);
    const amountWarning1865 = amountWarning.rates1865
    const amountWarning6670 = amountWarning.rates6670
    const amountWarning7175 = amountWarning.rates7175
    const amountWarning7680 = amountWarning.rates7680
    const is1865ActiveAgeBracket = activeAgeBracket === '18-65'
    const is6670ActiveAgeBracket = activeAgeBracket === '66-70'
    const is7175ActiveAgeBracket = activeAgeBracket === '71-75'
    const is7680ActiveAgeBracket = activeAgeBracket === '76-80'
    
    // ANNUAL PREMIUM AMOUNT
    const annualPremiumAmount = useSelector(selectAnnualPremiumAmount);
    const nmLValue = useSelector(selectNMLValue);
    const nelValue = useSelector(selectNELValue);
    const evidenceNotes = useSelector(selectEvidenceNotes);
    const isUpdateAnnualPremium = useSelector(selectIsUpdateAnnualPremium);
    const isEvidenceOfInsurability = useSelector(selectIsEvidenceOfInsurability);

    // DOCUMENT
    const documents = useSelector(selectFileDocuments)
    const isDraggingDocuments = useSelector(selectIsDraggingDocuments)
    const isUpdateDocuments = useSelector(selectIsUpdateDocuments)

    // REMARKS: Notes for Proposal
    const actNotePDF = useSelector(selectActNotePDF);
    const isShowActNotePDF = useSelector(selectIsShowActNotePDF);
    const isEditNotesForProposal = useSelector(selectIsEditNotesForProposal);
    const isEditingNotesForProposal = useSelector(selectIsEditingNotesForProposal);
    const noteForProposalActData = useSelector(selectNoteForProposalAct);
    // REMARKS: Notes for CFE
    const actNoteForCFE = useSelector(selectActNoteForCFE);
    const isEditNotesForCFE = useSelector(selectIsEditNotesForCFE);

    return {
        // RATES 
        ratesActiveTab,
        isUpdateRates,
        selectShowRates,
        rates1865,
        rates6670,
        rates7175,
        rates7680,
        bulkValue, 
        bulkWarning, 
        isBulkFillOpen, 
        selectedMonths,
        activeAgeBracket,
        is1865ActiveAgeBracket,
        is6670ActiveAgeBracket,
        is7175ActiveAgeBracket,
        is7680ActiveAgeBracket,
        amountWarning,
        amountWarning1865,
        amountWarning6670,
        amountWarning7175,
        amountWarning7680,


        // ANNUAL PREMIUM AMOUNT
        annualPremiumAmount,
        nmLValue,
        nelValue,
        evidenceNotes,
        isUpdateAnnualPremium,
        isEvidenceOfInsurability,

        // DOCUMENT
        documents,
        isDraggingDocuments,
        isUpdateDocuments,

        // REMARKS: Notes for Proposal
        actNotePDF,
        isShowActNotePDF,
        isEditNotesForProposal,
        isEditingNotesForProposal,
        noteForProposalActData,
        // REMARKS: Notes for CFE
        actNoteForCFE,
        isEditNotesForCFE
    }
}